import { Injectable, Injector } from '@angular/core';
import { ListHelperService } from 'core/services';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { MarsHttpDataService } from './mars-http-data.service';

@Injectable()
export class MarsLicenseService extends MarsHttpDataService {
  constructor(protected injector: Injector, private listHelperService: ListHelperService) {
    super(injector, '/licenses');
  }

  /**
   * Fetch of the mars licenses list
   * @param options
   */
  public fetch$(options?: {
    page: number;
    limit: number;
    sort: string;
    search: string;
    filters: object;
    aggregates: string;
    populate: string;
  }): Observable<any> {
    return this.fetchRequest(this.baseUrl, options);
  }

  public getLicense(license) {
    const url = `${this.baseUrl}/${license.id}`;

    return this.fetchRequest(url, this.getRequestOptions());
  }

  public anonymizeLicense(license) {
    const url = `${this.baseUrl}/${license.id}/anonymize`;

    return this.putRequest(url, JSON.stringify(license), this.getRequestOptions());
  }

  public deleteLicense(license) {
    const url = `${this.baseUrl}/${license.id}`;

    return this.deleteRequest(url, this.getRequestOptions());
  }

  public updateLicense(license) {
    return this.putRequest(`${this.baseUrl}/${license.id}`, license, this.getRequestOptions());
  }

  public updateLicensesBulk(data) {
    return this.putRequest(`${this.baseUrl}/bulk`, data, this.getRequestOptions());
  }

  public createLicensesBulk(groupId: string, csvData: any, clientId: string) {
    const formData: FormData = new FormData();
    formData.append('file', csvData);
    const params: HttpParams = new HttpParams({ fromObject: { clientId: clientId } });
    return lastValueFrom(this.http.post(`${this.baseUrl}/${groupId}`, formData, { params }))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  public getCsvLicenses(options?) {
    const url = `${this.baseUrl}/csv`;

    return this.fetchRequest(url, options);
  }
}
